import http from '@/biz/http.mjs'
import runAsync from '@/script/runAsync.mjs'

export const canCopyIdePromptBd = () => () => {
    return function (nodes) {
        const ns = [...nodes]

        if (1 !== ns.length) {
            return []
        }

        const {bizNodeType, pkid} = ns[0].data

        if (pkid && 'BD' === bizNodeType) {
            return ns
        }
        else {
            return []
        }
    }
}

export const canCopyIdePromptBdlogic = () => () => {
    return function (nodes) {
        const ns = [...nodes]

        if (0 === ns.length) {
            return []
        }

        const {ownerIdProp} = this.BizNode.BDLOGIC
        const {
            [ownerIdProp]: ownerId
        } = ns[0].data

        for (const n of ns) {
            const {
                bizNodeType,
                pkid,
                [ownerIdProp]: oid,
            } = n.data

            if (! (
                pkid &&
                'BDLOGIC' === bizNodeType &&
                oid === ownerId
            )) {
                return []
            }
        }

        return ns
    }
}

export const canCopyIdePromptIsrf = () => () => {
    return function (nodes) {
        const ns = [...nodes]

        if (1 !== ns.length) {
            return []
        }

        const {bizNodeType, pkid} = ns[0].data

        if (pkid && 'ISRF' === bizNodeType) {
            return ns
        }
        else {
            return []
        }
    }
}

export const canCopyIdePromptUe = () => () => {
    return function (nodes) {
        const ns = [...nodes]

        if (0 === ns.length) {
            return []
        }

        const {ownerIdProp} = this.BizNode.UE
        const {[ownerIdProp]: ownerId} = ns[0].data

        for (const n of ns) {
            const {
                bizNodeType,
                pkid,
                [ownerIdProp]: oid,
            } = n.data

            if (! (
                pkid &&
                'UE' === bizNodeType &&
                oid === ownerId
            )) {
                return []
            }
        }

        return ns
    }
}

export const canCopyIdePromptUi = () => () => {
    return function (nodes) {
        const ns = [...nodes]

        if (1 !== ns.length) {
            return []
        }

        const {bizNodeType, pkid} = ns[0].data

        if (pkid && 'UI' === bizNodeType) {
            return ns
        }
        else {
            return []
        }
    }
}

export const copyIdePromptBd = () => () => {
    return async function (nodes, specLevel) {
        const [node] = nodes
        const {bdCode: dpCode, prjId, sVer} = node.data

        const {prompt} = await runAsync(
            () => http.post(
                '/ide/copyIdePromptByBd',
                {dpCode, prjId, specLevel, sVer}
            ),

            {
                action: '拷贝节点Spec到剪贴板',
                success: {show: true},
            }
        )

        await navigator.clipboard.writeText(prompt)
        this.logger.info('节点Spec已拷贝到剪贴板', [node])
    }
}

export const copyIdePromptBdlogic = () => () => {
    return async function (nodes, specLevel) {
        const {bdCode: dpCode, prjId, sVer} = nodes[0].data
        const dppIds = nodes.map(n => n.data.pkid)

        const {prompt} = await runAsync(
            () => http.post(
                '/ide/copyIdePromptByBd',
                {dpCode, dppIds, prjId, specLevel, sVer}
            ),

            {
                action: '拷贝节点Spec到剪贴板',
                success: {show: true},
            }
        )

        await navigator.clipboard.writeText(prompt)
        this.logger.info('节点Spec已拷贝到剪贴板', nodes)
    }
}

export const copyIdePromptIsrf = () => () => {
    return async function (nodes, specLevel) {
        const [node] = nodes
        const {isrfCode: dpCode, prjId, sVer} = node.data

        const {prompt} = await runAsync(
            () => http.post(
                '/ide/copyIdePromptByIsrf',
                {dpCode, prjId, specLevel, sVer}
            ),

            {
                action: '拷贝节点Spec到剪贴板',
                success: {show: true},
            }
        )

        await navigator.clipboard.writeText(prompt)
        this.logger.info('节点Spec已拷贝到剪贴板', [node])
    }
}

export const copyIdePromptUe = () => () => {
    return async function (nodes, specLevel) {
        const {uiCode: dpCode, prjId, sVer} = nodes[0].data
        const dppIds = nodes.map(n => n.data.pkid)

        const {prompt} = await runAsync(
            () => http.post(
                '/ide/copyIdePromptByUi',
                {dpCode, dppIds, prjId, specLevel, sVer}
            ),

            {
                action: '拷贝节点Spec到剪贴板',
                success: {show: true},
            }
        )

        await navigator.clipboard.writeText(prompt)
        this.logger.info('节点Spec已拷贝到剪贴板', nodes)
    }
}

export const copyIdePromptUi = () => () => {
    return async function (nodes, specLevel) {
        const [node] = nodes
        const {uiCode: dpCode, prjId, sVer} = node.data

        const {prompt} = await runAsync(
            () => http.post(
                '/ide/copyIdePromptByUi',
                {dpCode, prjId, specLevel, sVer}
            ),

            {
                action: '拷贝节点Spec到剪贴板',
                success: {show: true},
            }
        )

        await navigator.clipboard.writeText(prompt)
        this.logger.info('节点Spec已拷贝到剪贴板', [node])
    }
}
